import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPostJson } from './client'

/**
 * Securitee > Network checks (`SecuriteeNetworkChecksController`): verificarea
 * pornita de om pe agentii de descoperire ai firmei din antet si serviciile
 * nesigure vazute de rularea ei. `requested_at` e UTC.
 */

export type NetworkCheckState = 'waiting' | 'starting' | 'running' | 'done' | 'busy' | 'failed' | 'done_no_run' | 'unknown'

export type NetworkRelay = { id: number; name: string; ranges: number }

export type NetworkCheck = {
  id: number
  relay: { id: number; name: string }
  requested_at: string
  state: NetworkCheckState
  note: string
  /** cat a tinut scanarea terminata */
  minutes: number | null
  /** numai in lista: constatarile unei verificari terminate */
  findings?: number | null
}

export type NetworkFinding = { service: string; port: string; title: string; why: string; evidence: string }

export type NetworkCheckDetail = NetworkCheck & {
  scanned: number
  devices: { ip: string; hostname: string; findings: NetworkFinding[] }[]
}

export type NetworkChecksPage = { relays: NetworkRelay[]; checks: NetworkCheck[]; can_run: boolean }

/** Starile in care verificarea se mai misca: ecranul se reciteste singur. */
export const MOVING: NetworkCheckState[] = ['waiting', 'starting', 'running']

export function networkChecksQuery() {
  return queryOptions({
    queryKey: ['securitee', 'network-checks'],
    queryFn: () => apiGet<NetworkChecksPage>('/securitee/network-checks'),
  })
}

export function networkCheckQuery(id: number) {
  return queryOptions({
    queryKey: ['securitee', 'network-checks', id],
    queryFn: () => apiGet<NetworkCheckDetail>(`/securitee/network-checks/${id}`),
  })
}

export function runNetworkCheck(relays: number[]) {
  return apiPostJson<NetworkChecksPage>('/securitee/network-checks', { relays })
}
